import UpdateAvailableSnackbar from "./components/UpdateAvailableSnackbar";
import { usePwaUpdate } from "./hooks/use-pwa-update";

const PwaUpdatePrompt = () => {
  const { isUpdateAvailable, applyUpdate, dismissUpdate } = usePwaUpdate();

  return (
    <UpdateAvailableSnackbar
      open={isUpdateAvailable}
      onReload={applyUpdate}
      onDismiss={dismissUpdate}
    />
  );
};

export default PwaUpdatePrompt;
